<template>
  <div class="basic_wrap">
    <!-- 顶部自定义导航 -->
    <div class="custom_header">
      <div class="back_btn" @click="$router.back()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </div>
      <div class="header_title">{{ $t('user.withdraw') }}</div>
      <div class="record_btn" @click="$router.push('/withdraw/record')">
        <img :src="require('../img/user/cash.png')">
      </div>
    </div>

    <div class="main_wrap">
      
      <!-- 1. 顶部收益资金卡片 -->
      <div class="card_box balance_card">
        <div class="balance_label">{{ $t('utils.lunlog43') }}</div>
        <div class="balance_amount">{{ common.currency_symbol_basic() }}{{ common.precision_basic(userBalance) }}</div>
      </div>

      <!-- 2. 提现账户卡片 -->
      <div class="card_box account_card" @click="show = true">
        <div class="account_label">{{ $t('withdraw.account') }}</div>
        <div class="account_select">
          <span class="selected_text">{{ withdraw_name }}</span>
          <van-icon name="arrow" color="#cbd5e1" class="arrow_icon" />
        </div>
      </div>
      <van-action-sheet
        v-model="show"
        :actions="wallets"
        cancel-text=""
        :description="$t('withdraw.accountPlaceholder')"
        close-on-click-action
        @select="onSelect"
      />

      <!-- 3. 提现金额卡片 -->
      <div class="card_box amount_card">
        <div class="amount_label">{{ $t('withdraw.amount') }}</div>
        <div class="amount_input_wrap">
          <span class="currency_prefix">{{ common.currency_symbol_basic() }}</span>
          <van-field 
            v-model="wallet.money" 
            type="number" 
            class="van_custom_input"
            :placeholder="$t('withdraw.amountPlaceholder')"
          />
        </div>
      </div>

      <!-- 4. 提款说明卡片 -->
      <div class="card_box rule_card">
        <div class="rule_title">{{ $t('utils.lunlog44') }}</div>
        <div class="rule_list">
          <div class="rule_item">
            <span class="r_label">{{ $t('withdraw.withdrawNum') }}</span>
            <span class="r_value">{{ withdraw_num }}{{ $t('utils.times' + times) }}</span>
          </div>
          <div class="rule_item">
            <span class="r_label">{{ $t('withdraw.withdrawAmount') }}</span>
            <span class="r_value">{{ common.currency_symbol_basic() }}{{ common.precision_basic(withdraw_min) }}</span>
          </div>
        </div>
        <div class="rule_desc">
          {{ $t('withdraw.withdrawTips') }}
        </div>
      </div>

      <!-- 5. 提交按钮 -->
      <div class="submit_btn" :class="wallet.money > 0 ? '' : 'disabled'" @click="submit">
        {{ $t('withdraw.withdrawNow') }}
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { Icon, ActionSheet, Field } from 'vant';
Vue.use(Icon).use(ActionSheet).use(Field);

export default {
  name: "Withdraw",
  components: { bsHeader },
  data() {
    return {
      rate: localStorage.getItem('rate'),
      data: [],
      userBalance: "0",
      frozenAmount: '0',
      withdraw_name: this.$t('withdraw.bindAccount'),
      show: false,
      wallets: [],
      wallet: {
        money: '',
        id: 0,
      },
      withdraw_num: 0,
      withdraw_min: 0,
      times: 0
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/getWallets').then(r => {
        this.userBalance = r.data.userBalance;
        this.frozenAmount = r.data.frozenAmount;
        this.withdraw_min = r.data.withdrawMin;
        this.withdraw_num = r.data.withdrawNum;
        this.times = r.data.withdrawNum;
        if (this.times > 1) this.times = 2;
        var walletList = [];
        r.data.wallets.forEach(item => {
          walletList.push({
            name: item.wname + "(" + item.account + ")",
            value: item.id,
            type: item.type,
          })
        })

        if (walletList.length == 0) {
          walletList.push({
            name: this.$t('withdraw.bindAccount'),
            value: 0,
            color: "#FF0000",
          })
        }
        this.withdraw_name = walletList[0].name;
        this.wallet.id = walletList[0].value;
        this.wallets = walletList;
      })
    },
    onSelect(item) {
      if (item.value == 0) {
        this.$router.push('/wallet')
      }
      this.withdraw_name = item.name;
      this.wallet.id = item.value;
    },
    submit() {
      if (this.wallet.id == 0) {
        this.$toast(this.$t('withdraw.accountEmpty'));
        return false;
      }
      if (this.wallet.money == "") {
        this.$toast(this.$t('withdraw.amountEmpty'));
        return false;
      }
      if (this.wallet.money - this.userBalance > 0) {
        this.$toast(this.$t('withdraw.amountError'));
        return false;
      }
      if (this.wallet.money - this.withdraw_min < 0) {
        this.$toast(this.$t('withdraw.withdrawAmount') + this.common.currency_symbol_basic() + this.common.precision_basic(this.withdraw_min));
        return false;
      }
      Fetch('/user/withdraw', {
        ...this.wallet,
      }).then(r => {
        this.$router.replace('/withdraw/record');
      })
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  min-height: 100vh;
  padding-bottom: 40px;
  /* 浅蓝网格背景 */
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

/* ================= 顶部自定义导航 ================= */
.custom_header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #ffffff;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e2e8f0;
  
  .back_btn {
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; width: 24px; height: 24px;
  }
  .header_title {
    font-size: 17px; font-weight: 700; color: #111;
  }
  .record_btn {
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    img { width: 22px; height: 22px; opacity: 0.7; }
  }
}

.main_wrap {
  padding: 16px;
}

/* ================= 通用白色卡片 ================= */
.card_box {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
  border: 1px solid rgba(176, 202, 240, 0.3);
}

/* ================= 1. 顶部收益资金卡片 ================= */
.balance_card {
  text-align: center;
  padding: 24px 16px;
  
  .balance_label {
    font-size: 14px; color: #64748b; margin-bottom: 6px;
  }
  .balance_amount {
    font-size: 24px; font-weight: 800; color: #1a2742;
  }
}

/* ================= 2. 提现账户卡片 ================= */
.account_card {
  display: flex; justify-content: space-between; align-items: flex-start;
  cursor: pointer; transition: background 0.2s;
  &:active { background: #fafbfc; }

  .account_label {
    font-size: 14px; font-weight: 600; color: #1a2742; margin-bottom: 6px;
  }
  .account_select {
    display: flex; align-items: center; gap: 8px;
    margin-top: 2px;
    .selected_text {
      font-size: 14px; color: #64748b;
    }
    .arrow_icon { font-size: 18px; }
  }
}

/* ================= 3. 提现金额卡片 ================= */
.amount_card {
  .amount_label {
    font-size: 14px; font-weight: 600; color: #1a2742; margin-bottom: 14px;
  }
  .amount_input_wrap {
    display: flex; align-items: center;
    background: #f8fafc; border: 1px solid #e2e8f0;
    border-radius: 12px; padding: 0 12px; height: 50px;

    .currency_prefix {
      font-size: 15px; font-weight: 700; color: #2563eb; margin-right: 8px;
    }
    .van_custom_input {
      flex: 1; padding: 0 !important; background: transparent !important;
      /deep/ .van-field__control {
        height: 50px; font-size: 15px; color: #1a2742;
        &::placeholder { color: #94a3b8; }
      }
    }
  }
}

/* ================= 4. 提款说明卡片 ================= */
.rule_card {
  padding: 16px;
  
  .rule_title {
    font-size: 14px; font-weight: 700; color: #1a2742; margin-bottom: 12px;
  }
  .rule_list {
    display: flex; flex-direction: column; gap: 6px; margin-bottom: 12px;
    .rule_item {
      display: flex; justify-content: space-between;
      font-size: 13px; color: #334155;
      .r_label { color: #64748b; font-weight: 400; }
      .r_value { font-weight: 500; color: #1a2742; }
    }
  }
  .rule_desc {
    padding-top: 10px; border-top: 1px solid #f1f5f9;
    font-size: 13px; color: #475569; line-height: 1.5;
  }
}

/* ================= 5. 提交按钮 ================= */
.submit_btn {
  width: 100%; height: 52px; border-radius: 26px;
  background: linear-gradient(135deg, #77a8ff 0%, #4e7dff 100%);
  color: #ffffff; font-size: 16px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: all 0.2s;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
  margin-top: 4px;
  
  &:active { transform: scale(0.96); opacity: 0.9; }
  &.disabled { opacity: 0.6; pointer-events: none; }
}

/* ================= Vant 弹窗修正 ================= */
/deep/ .van-action-sheet__item {
  text-align: left; padding: 14px 16px; font-size: 14px;
}
/deep/ .van-dialog__message { text-align: left; }
/deep/ .van-action-sheet { padding-bottom: 10px; }
</style>